/**
 * Coups de pouce — attendu 621 (définition du quotient).
 *
 * Routage par generator_key seul (deux cartes, pas de sousType).
 * Valeurs d'exemples HORS pools : 29/4 (numérateur > 25, jamais tiré) et
 * 4/5 pour la droite ((a+1)·b = 25 > 24 : couple jamais tiré).
 */

// Le POURQUOI de b × a/b = a, en barre partagée (idée utilisateur
// 2026-08-02) : diviser = couper, multiplier = réassembler. Pas-à-pas
// natif (data-etapes). 3/4 est atteignable dans un tirage du QCM :
// fuite ponctuelle assumée (~1/300, fiche de compréhension).
const SVG_BARRE_PARTAGE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 160" width="290" height="155" role="img" data-etapes="6"
     aria-label="On cherche le nombre qui, multiplié par 4, donne 3. Une barre de longueur 3 est coupée en 4 parts égales : chaque part vaut 3 divisé par 4, soit 3 quarts. Les 4 parts remises ensemble, c’est 4 fois 3 quarts, et cela refait exactement 3. Le nombre cherché, c’est donc 3 quarts">
  <style>
    .anim { opacity: 1; }
    [data-caption] { opacity: 0; }
    [data-caption="6"] { opacity: 1; }
    @media (prefers-reduced-motion: no-preference) {
      .b1 { opacity: 0; animation: cp621bar 12s linear infinite 0s; }
      .k1 { opacity: 0; animation: cp621cap 12s linear infinite 0s; }
      .b2 { opacity: 0; animation: cp621bar 12s linear infinite 2s; }
      .k2 { opacity: 0; animation: cp621cap 12s linear infinite 2s; }
      .b3 { opacity: 0; animation: cp621bar 12s linear infinite 4s; }
      .k3 { opacity: 0; animation: cp621cap 12s linear infinite 4s; }
      .b4 { opacity: 0; animation: cp621bar 12s linear infinite 6s; }
      .k4 { opacity: 0; animation: cp621cap 12s linear infinite 6s; }
      .b5 { opacity: 0; animation: cp621bar 12s linear infinite 8s; }
      .k5 { opacity: 0; animation: cp621cap 12s linear infinite 8s; }
      .b6 { opacity: 0; animation: cp621bar 12s linear infinite 10s; }
      .k6 { opacity: 0; animation: cp621capfin 12s linear infinite 10s; }
    }
    @keyframes cp621bar { 0%, 2% { opacity: 0; } 5%, 96% { opacity: 1; } 98%, 100% { opacity: 0; } }
    @keyframes cp621cap { 0%, 2% { opacity: 0; } 4%, 14% { opacity: 1; } 17%, 100% { opacity: 0; } }
    @keyframes cp621capfin { 0%, 2% { opacity: 0; } 4%, 96% { opacity: 1; } 98%, 100% { opacity: 0; } }
  </style>
  <line x1="20" y1="70" x2="20" y2="77" stroke="#64748b" stroke-width="1.5"/>
  <text x="20" y="90" text-anchor="middle" font-size="11" fill="#64748b">0</text>
  <line x1="100" y1="70" x2="100" y2="77" stroke="#64748b" stroke-width="1.5"/>
  <text x="100" y="90" text-anchor="middle" font-size="11" fill="#64748b">1</text>
  <line x1="180" y1="70" x2="180" y2="77" stroke="#64748b" stroke-width="1.5"/>
  <text x="180" y="90" text-anchor="middle" font-size="11" fill="#64748b">2</text>
  <line x1="260" y1="70" x2="260" y2="77" stroke="#64748b" stroke-width="1.5"/>
  <text x="260" y="90" text-anchor="middle" font-size="11" fill="#64748b">3</text>
  <g class="anim b1" data-etape="1">
    <rect x="20" y="40" width="240" height="30" fill="#fed7aa" fill-opacity="0.45" stroke="#f97316" stroke-width="2"/>
  </g>
  <g class="anim b2" data-etape="2">
    <line x1="80" y1="40" x2="80" y2="70" stroke="#dc2626" stroke-width="1.5" stroke-dasharray="3 2"/>
    <line x1="140" y1="40" x2="140" y2="70" stroke="#dc2626" stroke-width="1.5" stroke-dasharray="3 2"/>
    <line x1="200" y1="40" x2="200" y2="70" stroke="#dc2626" stroke-width="1.5" stroke-dasharray="3 2"/>
    <rect x="20" y="40" width="60" height="30" fill="#fb923c" fill-opacity="0.55"/>
    <text x="50" y="53" text-anchor="middle" font-size="10" font-weight="bold" fill="#b45309">3</text><line x1="43" y1="56" x2="57" y2="56" stroke="#b45309" stroke-width="1.2"/><text x="50" y="67" text-anchor="middle" font-size="10" font-weight="bold" fill="#b45309">4</text>
  </g>
  <g class="anim b3" data-etape="3">
    <text x="110" y="53" text-anchor="middle" font-size="10" font-weight="bold" fill="#b45309">3</text><line x1="103" y1="56" x2="117" y2="56" stroke="#b45309" stroke-width="1.2"/><text x="110" y="67" text-anchor="middle" font-size="10" font-weight="bold" fill="#b45309">4</text>
    <text x="170" y="53" text-anchor="middle" font-size="10" font-weight="bold" fill="#b45309">3</text><line x1="163" y1="56" x2="177" y2="56" stroke="#b45309" stroke-width="1.2"/><text x="170" y="67" text-anchor="middle" font-size="10" font-weight="bold" fill="#b45309">4</text>
    <text x="230" y="53" text-anchor="middle" font-size="10" font-weight="bold" fill="#b45309">3</text><line x1="223" y1="56" x2="237" y2="56" stroke="#b45309" stroke-width="1.2"/><text x="230" y="67" text-anchor="middle" font-size="10" font-weight="bold" fill="#b45309">4</text>
  </g>
  <g class="anim b4" data-etape="4">
    <text x="88" y="112" text-anchor="middle" font-size="13" font-weight="bold" fill="#f97316">4 ×</text>
    <text x="106" y="107" text-anchor="middle" font-size="10" font-weight="bold" fill="#f97316">3</text>
    <line x1="100" y1="110" x2="112" y2="110" stroke="#f97316" stroke-width="1.2"/>
    <text x="106" y="119" text-anchor="middle" font-size="10" font-weight="bold" fill="#f97316">4</text>
  </g>
  <g class="anim b5" data-etape="5">
    <rect x="20" y="40" width="240" height="30" fill="none" stroke="#f97316" stroke-width="3"/>
    <text x="122" y="112" font-size="13" font-weight="bold" fill="#0f172a">= 3 ✓</text>
  </g>
  <g class="anim b6" data-etape="6">
    <rect x="20" y="40" width="60" height="30" fill="none" stroke="#b45309" stroke-width="2.5"/>
  </g>
  <g class="anim k1" data-caption="1">
    <text x="150" y="146" text-anchor="middle" font-size="12" fill="#334155">voici la longueur <tspan font-weight="bold" fill="#f97316">3</tspan></text>
  </g>
  <g class="anim k2" data-caption="2">
    <text x="14" y="146" font-size="11.5" fill="#334155">coupée en 4 parts : chaque part vaut 3 ÷ 4 =</text>
    <text x="266" y="140" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">3</text><line x1="260" y1="143" x2="272" y2="143" stroke="#b45309" stroke-width="1.1"/><text x="266" y="152" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">4</text>
  </g>
  <g class="anim k3" data-caption="3">
    <text x="96" y="140" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">3</text><line x1="90" y1="143" x2="102" y2="143" stroke="#b45309" stroke-width="1.1"/><text x="96" y="152" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">4</text>
    <text x="111" y="146" text-anchor="middle" font-size="12" fill="#334155">+</text>
    <text x="126" y="140" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">3</text><line x1="120" y1="143" x2="132" y2="143" stroke="#b45309" stroke-width="1.1"/><text x="126" y="152" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">4</text>
    <text x="141" y="146" text-anchor="middle" font-size="12" fill="#334155">+</text>
    <text x="156" y="140" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">3</text><line x1="150" y1="143" x2="162" y2="143" stroke="#b45309" stroke-width="1.1"/><text x="156" y="152" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">4</text>
    <text x="171" y="146" text-anchor="middle" font-size="12" fill="#334155">+</text>
    <text x="186" y="140" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">3</text><line x1="180" y1="143" x2="192" y2="143" stroke="#b45309" stroke-width="1.1"/><text x="186" y="152" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">4</text>
    <text x="198" y="146" font-size="12" fill="#334155">…</text>
  </g>
  <g class="anim k4" data-caption="4">
    <text x="112" y="146" font-size="12" fill="#334155">…c’est <tspan font-weight="bold" fill="#f97316">4 ×</tspan></text>
    <text x="178" y="140" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#f97316">3</text><line x1="172" y1="143" x2="184" y2="143" stroke="#f97316" stroke-width="1.1"/><text x="178" y="152" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#f97316">4</text>
  </g>
  <g class="anim k5" data-caption="5">
    <text x="26" y="146" font-size="11.5" fill="#334155">ça refait exactement 3 : <tspan font-weight="bold" fill="#f97316">4 ×</tspan></text>
    <text x="190" y="140" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#f97316">3</text><line x1="184" y1="143" x2="196" y2="143" stroke="#f97316" stroke-width="1.1"/><text x="190" y="152" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#f97316">4</text>
    <text x="202" y="146" font-size="11.5" font-weight="bold" fill="#f97316">= 3</text> <text x="228" y="146" font-size="12" fill="#334155">✓</text>
  </g>
  <g class="anim k6" data-caption="6">
    <text x="60" y="146" font-size="12" fill="#334155">le nombre cherché, c’est</text>
    <text x="202" y="140" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">3</text><line x1="196" y1="143" x2="208" y2="143" stroke="#b45309" stroke-width="1.1"/><text x="202" y="152" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">4</text>
    <text x="214" y="146" font-size="12" fill="#334155">!</text>
  </g>
</svg>`.trim();

const FICHE_DEFINITION = {
    pages: [
        {
            // Page 1 = le concept en animation (arbitrage utilisateur 2026-08-02)
            titre: 'La définition du quotient',
            lignes: [
                'Le quotient de a par b est **le nombre qui, multiplié par b, donne a**.',
                'Ici, on cherche **le nombre qui, multiplié par 4, donne 3** :',
            ],
            svg: SVG_BARRE_PARTAGE,
        },
        {
            // Page 2 = le même geste sur une AUTRE valeur (hors pools)
            titre: 'Un exemple',
            lignes: [
                'Le nombre qui, multiplié par 4, donne 29, s\'écrit $\\dfrac{29}{4}$ : 29 en **haut**, 4 en **bas**. L\'ordre compte !',
                'Vérifie : $4 \\times \\dfrac{29}{4} = 29$ ✓ La multiplication retombe sur le nombre de départ.',
            ],
        },
    ],
};

// Reporter une fraction, animé (4/5 : couple hors pool, (a+1)·b = 25 > 24) :
// cinquièmes → 1er report → sauts suivants → pile sur 4 → 5 × 4/5 = 4.
const SVG_DROITE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 160" width="290" height="155" role="img" data-etapes="5"
     aria-label="Demi-droite graduée de 0 à 4 : de 0 à 1 il y a 5 parts égales, des cinquièmes. On reporte 5 fois la longueur 4 cinquièmes : chaque report avance de 4 graduations. Après les 5 reports, on tombe exactement sur l’entier 4 : 5 fois 4 cinquièmes égale 4">
  <style>
    .anim { opacity: 1; }
    [data-caption] { opacity: 0; }
    [data-caption="5"] { opacity: 1; }
    @media (prefers-reduced-motion: no-preference) {
      .d1 { opacity: 0; animation: cp621rep 10s linear infinite 0s; }
      .c1 { opacity: 0; animation: cp621repc 10s linear infinite 0s; }
      .d2 { opacity: 0; animation: cp621rep 10s linear infinite 2s; }
      .c2 { opacity: 0; animation: cp621repc 10s linear infinite 2s; }
      .d3 { opacity: 0; animation: cp621rep 10s linear infinite 4s; }
      .c3 { opacity: 0; animation: cp621repc 10s linear infinite 4s; }
      .d4 { opacity: 0; animation: cp621rep 10s linear infinite 6s; }
      .c4 { opacity: 0; animation: cp621repc 10s linear infinite 6s; }
      .d5 { opacity: 0; animation: cp621rep 10s linear infinite 8s; }
      .c5 { opacity: 0; animation: cp621repcf 10s linear infinite 8s; }
    }
    @keyframes cp621rep { 0%, 2% { opacity: 0; } 6%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
    @keyframes cp621repc { 0%, 2% { opacity: 0; } 5%, 18% { opacity: 1; } 22%, 100% { opacity: 0; } }
    @keyframes cp621repcf { 0%, 2% { opacity: 0; } 5%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
  </style>
  <line x1="10" y1="70" x2="284" y2="70" stroke="#475569" stroke-width="1.5"/>
  <polygon points="290,70 282,66 282,74" fill="#475569"/>
  <line x1="16.0" y1="62.0" x2="16.0" y2="78.0" stroke="#475569" stroke-width="1.5"/>
  <line x1="28.4" y1="65.0" x2="28.4" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="40.8" y1="65.0" x2="40.8" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="53.2" y1="65.0" x2="53.2" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="65.6" y1="65.0" x2="65.6" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="78.0" y1="62.0" x2="78.0" y2="78.0" stroke="#475569" stroke-width="1.5"/>
  <line x1="90.4" y1="65.0" x2="90.4" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="102.8" y1="65.0" x2="102.8" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="115.2" y1="65.0" x2="115.2" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="127.6" y1="65.0" x2="127.6" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="140.0" y1="62.0" x2="140.0" y2="78.0" stroke="#475569" stroke-width="1.5"/>
  <line x1="152.4" y1="65.0" x2="152.4" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="164.8" y1="65.0" x2="164.8" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="177.2" y1="65.0" x2="177.2" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="189.6" y1="65.0" x2="189.6" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="202.0" y1="62.0" x2="202.0" y2="78.0" stroke="#475569" stroke-width="1.5"/>
  <line x1="214.4" y1="65.0" x2="214.4" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="226.8" y1="65.0" x2="226.8" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="239.2" y1="65.0" x2="239.2" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="251.6" y1="65.0" x2="251.6" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="264.0" y1="62.0" x2="264.0" y2="78.0" stroke="#475569" stroke-width="1.5"/>
  <line x1="276.4" y1="65.0" x2="276.4" y2="75.0" stroke="#475569" stroke-width="1"/>
  <text x="16.0" y="92" text-anchor="middle" font-size="11" fill="#475569">0</text>
  <text x="78.0" y="92" text-anchor="middle" font-size="11" fill="#475569">1</text>
  <text x="140.0" y="92" text-anchor="middle" font-size="11" fill="#475569">2</text>
  <text x="202.0" y="92" text-anchor="middle" font-size="11" fill="#475569">3</text>
  <text x="264.0" y="92" text-anchor="middle" font-size="11" fill="#475569">4</text>
  <g class="anim d1" data-etape="1">
    <rect x="16.0" y="60" width="62.0" height="20" fill="#fed7aa" fill-opacity="0.5"/>
  </g>
  <g class="anim d2" data-etape="2">
    <path d="M 16.0 70 Q 40.8 46 65.6 70" fill="none" stroke="#f97316" stroke-width="1.6"/>
    <circle cx="65.6" cy="70" r="2.6" fill="#f97316"/>
    <text x="65.6" y="30.0" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#f97316">4</text><line x1="59.1" y1="33.5" x2="72.1" y2="33.5" stroke="#f97316" stroke-width="1.1"/><text x="65.6" y="42.5" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#f97316">5</text>
  </g>
  <g class="anim d3" data-etape="3">
    <path d="M 65.6 70 Q 90.4 46 115.2 70" fill="none" stroke="#f97316" stroke-width="1.6"/>
    <circle cx="115.2" cy="70" r="2.6" fill="#f97316"/>
    <path d="M 115.2 70 Q 140.0 46 164.8 70" fill="none" stroke="#f97316" stroke-width="1.6"/>
    <circle cx="164.8" cy="70" r="2.6" fill="#f97316"/>
    <path d="M 164.8 70 Q 189.6 46 214.4 70" fill="none" stroke="#f97316" stroke-width="1.6"/>
    <circle cx="214.4" cy="70" r="2.6" fill="#f97316"/>
  </g>
  <g class="anim d4" data-etape="4">
    <path d="M 214.4 70 Q 239.2 46 264.0 70" fill="none" stroke="#f97316" stroke-width="1.6"/>
    <circle cx="264.0" cy="70" r="4.5" fill="none" stroke="#f97316" stroke-width="2.5"/>
  </g>
  <g class="anim d5" data-etape="5">
    <text x="118" y="122" text-anchor="end" font-size="13" font-weight="bold" fill="#f97316">5 ×</text>
    <text x="132.0" y="110.0" text-anchor="middle" font-size="10" font-weight="bold" fill="#f97316">4</text><line x1="125.5" y1="113.5" x2="138.5" y2="113.5" stroke="#f97316" stroke-width="1.1"/><text x="132.0" y="122.5" text-anchor="middle" font-size="10" font-weight="bold" fill="#f97316">5</text>
    <text x="144" y="122" font-size="13" font-weight="bold" fill="#0f172a">= 4 ✓</text>
  </g>
  <g class="anim c1" data-caption="1">
    <text x="150" y="146" text-anchor="middle" font-size="11.5" fill="#334155">de 0 à 1, il y a <tspan font-weight="bold" fill="#b45309">5 parts</tspan> : des <tspan font-weight="bold" fill="#b45309">cinquièmes</tspan></text>
  </g>
  <g class="anim c2" data-caption="2">
    <text x="120" y="146" text-anchor="end" font-size="11.5" fill="#334155">on reporte</text>
    <text x="134.0" y="134.0" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#f97316">4</text><line x1="127.5" y1="137.5" x2="140.5" y2="137.5" stroke="#f97316" stroke-width="1.1"/><text x="134.0" y="146.5" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#f97316">5</text>
    <text x="146" y="146" font-size="11.5" fill="#334155">: on avance de <tspan font-weight="bold" fill="#f97316">4 graduations</tspan></text>
  </g>
  <g class="anim c3" data-caption="3">
    <text x="150" y="146" text-anchor="middle" font-size="11.5" fill="#334155">on reporte encore : <tspan font-weight="bold" fill="#f97316">4 graduations</tspan> à chaque saut</text>
  </g>
  <g class="anim c4" data-caption="4">
    <text x="150" y="146" text-anchor="middle" font-size="11.5" fill="#334155">après les 5 reports, on tombe <tspan font-weight="bold" fill="#f97316">pile sur 4</tspan> !</text>
  </g>
  <g class="anim c5" data-caption="5">
    <text x="150" y="146" text-anchor="middle" font-size="11.5" fill="#334155">5 × 4 graduations = 20 graduations : <tspan font-weight="bold" fill="#b45309">4 unités</tspan></text>
  </g>
</svg>`.trim();

const FICHE_DROITE = {
    pages: [
        {
            titre: 'Reporter une fraction sur la droite',
            lignes: [
                'Le **dénominateur** te dit en combien de **parts égales** une unité est coupée.',
                'Reporter $\\dfrac{4}{5}$, c\'est avancer de **4 graduations** à chaque saut : après **5 sauts**, tu tombes **pile sur 4**.',
            ],
            svg: SVG_DROITE,
        },
    ],
};

const CP_621 = {
    def_quotient_qcm: FICHE_DEFINITION,
    def_quotient_texte: FICHE_DEFINITION,
    def_quotient_vf: FICHE_DEFINITION,
    def_quotient_relier: FICHE_DEFINITION,
    def_quotient_drag: FICHE_DEFINITION,
    def_quotient_trou_saisie: FICHE_DEFINITION,
    droite_graduee_svg: FICHE_DROITE,
};

export default CP_621;
